import styled from "styled-components";

export const StyledContainer = styled("div")`
  display:flex;
  flex-direction:column;
  text-align: center;
  justify-content: center;
  align-items: center;
  margin:50px;
`;

export const ImageContainer = styled("div")`
  display:flex;
  flex-direction:column;
  text-align: center;
  justify-content: center;
  align-items: center;
  margin:50px;
`;

export const InfoText = styled("p")`
  font-size:14px;
  margin-top:5px;
  margin-right:5px;
  direction:rtl;
  text-align:center;
  width:100%;
  color:black;
`;